export default __webpack_public_path__ + "static/media/bg_login.386a2e49.png";